import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiResponse } from "../../APIResponse";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import axios from "axios";

export const UserLogin = createAsyncThunk(
  "UserLogin",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.USERLOGIN,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);
export const LoginGitHub = createAsyncThunk(
  "LoginGitHub",
  async (data, { dispatch }) => {
    try {
      const formData = new FormData();
      formData.append("code", data);
      if (window.location.href.includes(`${process.env.REACT_APP_DEV}`)) {
        formData.append("signupfrom", "Developer");
      } else {
        formData.append("signupfrom", "Datafactory");
      }
      const resData = await axios.post(
        API_URL.BASEURL + API_URL.LOGIN_GITHUB,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      let response = apiResponse(true, resData?.data);
      return response;
    } catch (error) {}
  }
);
export const UserSignUp = createAsyncThunk(
  "UserSignUp",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.SUBSCRIBERS_SAVE,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);


export const SEND_SIGNUP_OTP = createAsyncThunk(
    "SEND_SIGNUP_OTP",
    async (data, { dispatch }) => {
        try {
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.SEND_SIGNUP_OTP,
                    body: data,
                },
                true
            );
            let response = apiResponse(true, resData);
            return response;
        } catch (error) { }
    }
);


export const VERIFY_SIGNUP_OTP = createAsyncThunk(
    "VERIFY_SIGNUP_OTP",
    async (data, { dispatch }) => {
        try {
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.VERIFY_SIGNUP_OTP,
                    body: data,
                },
                true
            );
            let response = apiResponse(true, resData);
            return response;
        } catch (error) { }
    }
);


//export const VERIFY_SIGNUP_OTP = createAsyncThunk(
//    "VERIFY_SIGNUP_OTP",
//    async (data, { dispatch }) => {
        
//        try {
//            let resData = await apiCall(
//                {
//                    method: "GET",
//                    url: API_URL.BASEURL + API_URL.VERIFY_SIGNUP_OTP + `?Id=${data.emailotpid}&otp=${data.otp}`,
//                },
//                false
//            );
//            let response = apiResponse(true, resData);
//            return response;
//        } catch (error) { }
//    }
//);



export const VerifyOtp = createAsyncThunk(
  "VerifyOtp",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.VERIFY_OTP,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);
export const ChangePassword = createAsyncThunk(
  "ChangePassword",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.VERIFY_OTP,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

export const Enable2FA = createAsyncThunk(
  "Enable2FA",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.AUTH.ENABLE_2FA,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const Verify2FA = createAsyncThunk(
  "Verify2FA",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.AUTH.VERIFY_2FA,
          body: data,
        },
        false
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

export const Send2FAEmailOTP = createAsyncThunk(
  "Send2FAEmailOTP",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.AUTH.SEND_2FA_EMAIL_OTP,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);
export const Verify2FAEmailOTP = createAsyncThunk(
  "Verify2FAEmailOTP",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.AUTH.VERIFY_2FA_EMAIL_OTP,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);
export const Disable2FA = createAsyncThunk(
  "Disable2FA",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.AUTH.DISABLE_2FA,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

const initialState = {
  UserLoginData: {
    data: null,
    error: null,
  },
  LoginGitHubData: {
    data: null,
    error: null,
  },
  UserSignUpData: {
    data: null,
    error: null,
  },
  VerifyOtpData: {
    data: null,
    error: null,
  },
  Enable2FAData: {
    data: null,
    error: null,
  },
  Verify2FAData: {
    data: null,
    error: null,
  },
  Send2FAEmailOTPData: {
    data: null,
    error: null,
  },
  Verify2FAEmailOTPData: {
    data: null,
    error: null,
  },
  Disable2FAData: {
    data: null,
    error: null,
  },
};

const AuthFlowSlice = createSlice({
  name: "UserLoginMain",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(UserLogin.fulfilled, (state, action) => {
        state.UserLoginData.data = action.payload;
      })
      .addCase(UserLogin.rejected, (state, action) => {
        state.UserLoginData.error = action.error.message;
      })
      .addCase(LoginGitHub.fulfilled, (state, action) => {
        state.LoginGitHubData.data = action.payload;
      })
      .addCase(LoginGitHub.rejected, (state, action) => {
        state.LoginGitHubData.error = action.error.message;
      })
      .addCase(UserSignUp.fulfilled, (state, action) => {
        state.UserSignUpData.data = action.payload;
      })
      .addCase(UserSignUp.rejected, (state, action) => {
        state.UserSignUpData.error = action.error.message;
      })
      .addCase(VerifyOtp.fulfilled, (state, action) => {
        state.VerifyOtpData.data = action.payload;
      })
      .addCase(VerifyOtp.rejected, (state, action) => {
        state.VerifyOtpData.error = action.error.message;
      })
      .addCase(Enable2FA.fulfilled, (state, action) => {
        state.Enable2FAData.data = action.payload;
      })
      .addCase(Enable2FA.rejected, (state, action) => {
        state.Enable2FAData.error = action.error.message;
      })
      .addCase(Verify2FA.fulfilled, (state, action) => {
        state.Verify2FAData.data = action.payload;
      })
      .addCase(Verify2FA.rejected, (state, action) => {
        state.Verify2FAData.error = action.error.message;
      })
      .addCase(Send2FAEmailOTP.fulfilled, (state, action) => {
        state.Send2FAEmailOTPData.data = action.payload;
      })
      .addCase(Send2FAEmailOTP.rejected, (state, action) => {
        state.Send2FAEmailOTPData.error = action.error.message;
      })
      .addCase(Verify2FAEmailOTP.fulfilled, (state, action) => {
        state.Verify2FAEmailOTPData.data = action.payload;
      })
      .addCase(Verify2FAEmailOTP.rejected, (state, action) => {
        state.Verify2FAEmailOTPData.error = action.error.message;
      })
      .addCase(Disable2FA.fulfilled, (state, action) => {
        state.Disable2FAData.data = action.payload;
      })
      .addCase(Disable2FA.rejected, (state, action) => {
        state.Disable2FAData.error = action.error.message;
      });
  },
});

export const { UserLoginData, LoginGitHubData, UserSignUpData, VerifyOtpData } =
  AuthFlowSlice.actions;
export default AuthFlowSlice.reducer;
